<script setup lang="ts">
import { cn } from "@/lib/utils";
import { eventBus } from "#bb/lib/eventBus";
import { useTemplating, buildTemplateContext } from "#bb/composables/useTemplating";

// 1) Define props & emits
const props = defineProps<{ id: string; text?: string }>();

// 2) Access content manager for store updates
const { getContentById } = useContentManager();
// Use a computed property so updates from the store are reflected
const definitionData = computed(() => getContentById(props.id) || { text: props.text });

// Inject report provider for templating
const report = inject<any | null>("report", null);
const templateContext = computed(() => buildTemplateContext(report));
const logger = useLogger("CardHeaderTitle");
const { applyTemplate } = useTemplating(templateContext, { logger });
const templatedText = computed(() => applyTemplate(definitionData.value?.text || ""));


// 4) Expose an "Edit" command in the context menu
const commands = [
  {
    id: "editors-group",
    type: "group",
    name: "Editors",
    description: "Edit the title text",
    commands: [
      {
        id: "edit",
        name: "Edit Title",
        description: "Edit Card Header Title",
        action: async () => {
          eventBus.emit(`component:onEdit:${props.id}`, {
            data: { ...definitionData.value },
          });
        },
        icon: "lucide:edit",
      },
    ],
  },
];

defineExpose({
  commands,
  properties: {
    id: props.id,
    name: "Card Header Title",
    icon: "lucide:letter-text",
  },
});
</script>

<template>
  <!-- Actual ShadCN card title rendering -->
  <CardTitle :class="cn($attrs.class ?? '')">
    {{ templatedText }}
  </CardTitle>

</template>

<script lang="ts">
import { ComponentDefinitionIds } from "#bb/lib/componentDefinitionIds";
export default {
  componentId: ComponentDefinitionIds.CARD_HEADER_TITLE,
  editor: () => import("#bb/components/editor/container/card/header/title.vue"),
  icon: "lucide:letter-text",
  type: "Card Header Title",
  description: "Displays the card header title text.",
  default: {
    text: "Default Title",
  },
  categories: ["Layout"],
  hiddenUntilFiltered: true,
};
</script>
